import { Prisma } from '@repo/database/src/types';
import type { CountrySubdivision } from '@repo/database/src/types';
import { Type } from 'class-transformer';
import { IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';

/**
 * Filter DTO for countries in the admin dashboard
 */
export class AdminCountriesSubdivisionsFilterDto {
  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsString()
  code?: string;

  @IsOptional()
  @IsString()
  countryId?: string;
}

/**
 * Main DTO for getting countries list with filters, pagination, and sorting
 */
export class GetAdminCountriesSubdivisionsDto extends PaginationOptionsDto {
  @IsObject()
  @ValidateNested()
  @IsOptional()
  @Type(() => AdminCountriesSubdivisionsFilterDto)
  filter?: AdminCountriesSubdivisionsFilterDto;

  @IsOptional()
  sorts?: Array<{ field: string; order: Prisma.SortOrder }>;
}

/**
 * Response DTO for admin countries list
 */
export interface AdminCountriesSubdivisionsResponseDto {
  subdivisions: CountrySubdivision[];
  totalCount: number;
}
